/* OTP and PIN sign-in on the login page. Everything it shows (tabs, lengths, wording)
   comes from the server in #rfhq-auth-root's data-config; nothing is written here. */
(function () {
	const root = document.getElementById("rfhq-auth-root");
	if (!root || !window.rfhqUI) return;

	const cfg = JSON.parse(root.dataset.config || "{}");
	const S = cfg.strings || {};
	const { h, segmented, codeInput, pinPad, call, localPath } = window.rfhqUI;
	// Only the password fields are swapped out. Social logins, the email link and anything else on the
	// login card stay where they are on every tab: this panel sits beside them, it does not replace them.
	const passwordBlocks = root.parentElement.querySelectorAll("[data-rfhq-password-block]");
	const state = { csrf: "", timer: null };
	const fill = (text, ...values) => values.reduce((out, v, i) => out.replace("{" + i + "}", v), text || "");

	const tabs = segmented({ items: cfg.tabs, active: cfg.default_tab, label: "", onChange: showTab });
	const message = h("p", { class: "rfhq-auth__msg", role: "alert", "aria-live": "assertive", hidden: true });
	const panel = h("div", { class: "rfhq-auth__panel" });
	tabs.el.hidden = (cfg.tabs || []).length < 2;  // one way in: nothing to choose between
	root.classList.toggle("is-single", tabs.el.hidden);
	root.append(tabs.el, message, panel);
	root.hidden = false;
	showTab(cfg.default_tab);
	if (cfg.google_one_tap && cfg.google_one_tap.google_client_id) googleOneTap(cfg.google_one_tap);  // (the Google card: a person who is signed in to Google is one tap from in)

	/* ---- helpers ---- */
	function say(text, kind) {
		message.textContent = text || "";
		message.hidden = !text;
		message.className = "rfhq-auth__msg" + (kind ? " is-" + kind : "");
	}
	const rpc = (name, args) => call("raftor_websitehq.auth.api." + name, args, { csrf: state.csrf, fallback: S.error });
	// Where to go: the step a hand-off names, else the page they came from, else their role's home page, else the front page.
	function go(path, home) {
		window.location.href = localPath(path) || localPath(new URLSearchParams(location.search).get("redirect-to")) || localPath(home) || "/";
	}
	// The link someone arrived by may carry ?intent=<journey>; it is passed along untouched for onboarding to read.
	function intent() { return new URLSearchParams(location.search).get("intent") || undefined; }
	function track(name, params) { if (typeof window.rfhqTrack === "function") window.rfhqTrack(name, params); }  // (the site's analytics, when connected: integrationhq analytics_tag.js)
	function clearTimer() { if (state.timer) { clearInterval(state.timer); state.timer = null; } }
	function show(...nodes) { clearTimer(); say(""); panel.replaceChildren(...nodes); const first = panel.querySelector("input"); if (first) first.focus(); }
	function busy(button, on) { button.disabled = on; if (on) { button.dataset.label = button.textContent; button.textContent = S.sending; } else if (button.dataset.label) { button.textContent = button.dataset.label; } }
	function identifierField(value) {
		// One way in, a mobile number: the field starts with the country code (the site's own), opens a number keyboard and takes a number as people write it.
		const single = !!cfg.single;
		return h("input", { class: "form-control rfhq-auth__input" + (single ? " rfhq-auth__input--phone" : ""), type: single ? "tel" : "text", id: "rfhq_auth_identifier", value: value || (single ? (cfg.default_country_code || "") : ""),
			placeholder: S.identifier_placeholder, "aria-label": S.identifier_label, autocomplete: single ? "tel" : "username", inputmode: single ? "tel" : undefined, autocapitalize: "none", spellcheck: "false" });
	}
	function reasonText(data) {
		return data.reason === "mismatch" ? fill(S.otp_mismatch, String(data.tries_left))
			: data.reason === "too_many_tries" ? S.otp_too_many : S.otp_expired;
	}
	/* "Send by: SMS | WhatsApp", only when more than one mobile channel is on and a mobile number is typed. */
	function channelPicker(input) {
		const options = cfg.mobile_channels || [];
		if (options.length < 2) return { el: null, value: undefined };
		let chosen = options[0].key;
		const seg = segmented({ items: options, active: chosen, label: S.send_via, onChange: (key) => { chosen = key; } });
		const el = h("div", { class: "rfhq-auth__channel", hidden: true }, h("span", { class: "rfhq-auth__hint", text: S.send_via }), seg.el);
		const sync = () => { el.hidden = !input.value.trim() || input.value.includes("@"); };
		input.addEventListener("input", sync); sync();
		return { el, get value() { return input.value.includes("@") ? undefined : chosen; } };
	}
	function link(text, onclick) { return h("button", { type: "button", class: "rfhq-auth__link", text, onclick }); }
	/* A password box with a Show/Hide button (a phone keyboard makes typos easy to miss). */
	function secretField(autocomplete, label) {
		const input = h("input", { class: "form-control rfhq-auth__input", type: "password", autocomplete, "aria-label": label, placeholder: label, id: "rfhq_auth_secret" });
		const toggle = h("button", { type: "button", class: "rfhq-auth__link rfhq-auth__show", text: S.show });
		toggle.addEventListener("click", () => { const reveal = input.type === "password"; input.type = reveal ? "text" : "password"; toggle.textContent = reveal ? S.hide : S.show; });
		return { input, el: h("div", { class: "rfhq-auth__secret" }, input, toggle) };
	}

	/* ---- tabs ---- */
	function showTab(key) {
		tabs.select(key);
		passwordBlocks.forEach((block) => { block.hidden = key !== "password" || !!cfg.password; });  // our own password screen takes the place of the standard fields unless staff ask for them
		if (key === "otp") screenOtpStart();
		else if (key === "pin") screenPinLogin();
		else if (key === "password" && cfg.password) screenPasswordLogin();
		else { clearTimer(); say(""); panel.replaceChildren(); }
	}

	/* ---- "enter your email or number, press Send": shared by sign-in and forgot-PIN ---- */
	function identifierForm({ prefill, title, hint, hintFirst, back, start, onSent }) {
		const input = identifierField(prefill);
		const picker = channelPicker(input);
		const send = h("button", { type: "submit", class: "btn btn-primary btn-block rfhq-auth__primary", text: S.send_otp });
		const form = h("form", { class: "rfhq-auth__form", novalidate: true },
			title ? h("h3", { class: "rfhq-auth__title", text: title }) : null, hint && hintFirst ? h("p", { class: "rfhq-auth__hint", text: hint }) : null, input, picker.el, send,
			hint && !hintFirst ? h("p", { class: "rfhq-auth__hint", text: hint }) : null,
			consentLine(),
			back ? link(S.back, () => back(input.value)) : null);
		form.addEventListener("submit", async (event) => {
			event.preventDefault();
			if (!input.value.trim()) { say(S.identifier_needed, "error"); return; }
			busy(send, true);
			const result = await start(input.value.trim(), picker.value);
			busy(send, false);
			if (!result.ok) { say(result.message, "error"); return; }
			onSent(result.data, input);
		});
		return form;
	}

	/* The consent line under the button: plain text and links to pages on this site (the site's own wording, from its settings). */
	function consentLine() {
		const parts = (cfg.consent || []).map((p) => p.href && localPath(p.href)
			? h("a", { href: localPath(p.href), target: "_blank", rel: "noopener", text: p.label }) : document.createTextNode(p.text || p.label || ""));
		return parts.length ? h("p", { class: "rfhq-auth__consent" }, ...parts) : null;
	}

	/* ---- a number proved by a provider (Firebase): the server hands over the provider's public settings and the scripts that run it; the site never sees the code ---- */
	const loaded = {};
	function loadScript(src) {   // only https addresses or this site's own assets, each once
		if (!/^(https:\/\/|\/assets\/)/.test(src || "")) return Promise.reject(new Error("script"));
		return loaded[src] || (loaded[src] = new Promise((resolve, reject) => {
			const el = document.createElement("script"); el.src = src; el.async = false; el.onload = resolve; el.onerror = () => { delete loaded[src]; reject(new Error("script")); };
			document.head.appendChild(el);
		}));
	}
	async function proofStart(proof) {   // runs the provider: it texts the number; returns the provider's browser part
		for (const src of proof.scripts || []) await loadScript(src);
		await loadScript(proof.module);
		const part = (window.rfhqPhoneProof || {})[proof.provider];
		if (!part) throw new Error("provider");
		await part.send(proof.options, proof.phone);
		return part;
	}

	/* ---- OTP sign-in / sign-up ---- */
	function screenOtpStart(prefill, note) {
		const start = (identifier, channel) => rpc("start_otp_signin", { identifier, channel, intent: intent() });
		const codeScreen = (data, input, part) => screenCode({
			masked: data.masked_identifier, reference: data.reference, resendIn: data.resend_in, length: data.length,
			resend: part ? async () => {   // a new challenge, and the provider texts again
				const again = await start(input.value.trim(), undefined);
				if (again.ok && again.data.proof) { try { part = await proofStart(again.data.proof); } catch (e) { return { ok: false, message: S.proof_send_failed }; } }
				return again;
			} : () => start(input.value.trim(), undefined),
			verify: part ? async (reference, code) => {
				let token;
				try { token = await part.confirm(code); } catch (e) { return { ok: false, message: S.proof_wrong }; }
				return rpc("complete_proof_signin", { reference, proof: token });
			} : (reference, code) => rpc("complete_otp_signin", { reference, code }),
			onVerified: signedIn, back: () => screenOtpStart(input.value),
		});
		show(identifierForm({
			prefill, hintFirst: !!cfg.single, hint: cfg.single ? S.single_hint : (cfg.signup_open ? S.new_here : S.otp_note), start,
			onSent: async (data, input) => {
				track("sign_in_code_sent", { method: data.proof ? "text" : "other" });  // (a step name and a method only: never the number or the email)
				if (!data.proof) return codeScreen(data, input, null);
				let part;
				try { part = await proofStart(data.proof); } catch (e) { say(S.proof_send_failed, "error"); return; }
				codeScreen(data, input, part);
			},
		}));
		if (cfg.staff_link) panel.append(h("div", { class: "rfhq-auth__staff" }, link(S.staff_sign_in, () => showStandardFields())));  // the standard fields, for staff, as a quiet link (the Password tab carries it where there is one)
		if (note) say(note, "info");
	}

	function screenCode(ctx) {
		let reference = ctx.reference;
		let length = ctx.length || cfg.otp_length;  // the server says how long this code is (a mobile code while SMS is stubbed is not as long as an email code)
		const code = codeInput({ length, label: S.code_label, onComplete: () => submit() });
		const verify = h("button", { type: "button", class: "btn btn-primary btn-block rfhq-auth__primary", text: S.verify, onclick: () => submit() });
		const again = h("button", { type: "button", class: "rfhq-auth__link", disabled: true });
		const wrap = h("div", { class: "rfhq-auth__form" },
			h("h3", { class: "rfhq-auth__title", text: S.code_title }),
			h("p", { class: "rfhq-auth__sub", text: fill(S.sent_to, ctx.masked) }),
			code.el, verify, again, link(S.change_identifier, ctx.back));
		show(wrap); code.focus();

		let left = ctx.resendIn || 0;
		function tick() {
			again.disabled = left > 0;
			again.textContent = left > 0 ? fill(S.resend_in, String(left)) : S.resend;
			if (left > 0) left -= 1; else clearTimer();
		}
		tick(); if (left > 0) state.timer = setInterval(tick, 1000);
		again.addEventListener("click", async () => {
			const result = await ctx.resend();
			if (!result.ok) { say(result.message, "error"); return; }
			reference = result.data.reference; left = result.data.resend_in || 0; length = result.data.length || length; code.clear(); code.focus(); say(""); tick();
			if (left > 0) { clearTimer(); state.timer = setInterval(tick, 1000); }
		});

		async function submit() {
			if (code.value.length !== length || verify.disabled) return;
			if (ctx.collect) { ctx.collect(reference, code.value); return; }
			busy(verify, true);
			const result = await ctx.verify(reference, code.value);
			busy(verify, false);
			if (!result.ok) { say(result.message, "error"); return; }
			const data = result.data;
			if (data.verified || data.reset) { track("sign_in_done", {}); ctx.onVerified(data, code.value, reference); return; }
			track("sign_in_code_wrong", { reason: String(data.reason || "") });
			code.clear(); code.focus();
			say(reasonText(data), "error");
		}
	}

	// Signed in on another device: nothing has started yet. Ask, and only on "switch" finish the sign-in.
	function screenSwitch(token) {
		const yes = h("button", { type: "button", class: "btn btn-primary btn-block rfhq-auth__primary", text: S.switch_confirm });
		yes.addEventListener("click", async () => {
			busy(yes, true);
			const result = await rpc("switch_device", { switch_token: token });
			busy(yes, false);
			if (!result.ok) { say(result.message, "error"); return; }
			signedIn(result.data);
		});
		show(h("div", { class: "rfhq-auth__form" },
			h("h3", { class: "rfhq-auth__title", text: S.switch_title }),
			h("p", { class: "rfhq-auth__sub", text: S.switch_sub }),
			yes, link(S.switch_cancel, () => showTab(cfg.default_tab))));
	}

	function signedIn(data) {
		if (data.switch_required) { screenSwitch(data.switch_token); return; }
		state.csrf = data.csrf_token || state.csrf;
		if (cfg.pin && !data.has_pin) screenSetPin({ done: (ok) => go(data.redirect_to, data.home), save: (pin) => rpc("set_pin", { pin_value: pin }), skippable: true });
		else go(data.redirect_to, data.home);
	}

	/* ---- choose a PIN (twice) ---- */
	function screenSetPin({ save, done, skippable, title }) {
		let first = "";
		const pad = pinPad({ length: cfg.pin_length, label: S.pin_label, onComplete: onEntered });
		const heading = h("h3", { class: "rfhq-auth__title", text: title || S.set_pin_title });
		const sub = h("p", { class: "rfhq-auth__sub", text: S.set_pin_sub });
		const nodes = [heading, sub, pad.el];
		if (skippable) nodes.push(link(S.skip, () => done(false)));
		show(...nodes);
		async function onEntered(value) {
			if (!first) { first = value; pad.clear(); heading.textContent = S.confirm_pin_title; sub.textContent = ""; return; }
			if (value !== first) { first = ""; pad.clear(); pad.shake(); heading.textContent = title || S.set_pin_title; sub.textContent = S.set_pin_sub; say(S.pins_differ, "error"); return; }
			const result = await save(value);
			if (result.leave) return;
			if (!result.ok) { first = ""; pad.clear(); heading.textContent = title || S.set_pin_title; say(result.message, "error"); return; }
			done(true);
		}
	}

	/* ---- PIN sign-in ---- */
	function screenPinLogin(prefill, note) {
		const input = identifierField(prefill);
		const pad = pinPad({ length: cfg.pin_length, label: S.pin_label, onComplete: attempt });
		show(h("div", { class: "rfhq-auth__form" }, h("h3", { class: "rfhq-auth__title", text: S.pin_title }), input, pad.el, link(S.forgot_pin, () => screenForgot(input.value))));
		if (note) say(note, "info");
		async function attempt(pin) {
			if (!input.value.trim()) { pad.clear(); say(S.identifier_needed, "error"); input.focus(); return; }
			const result = await rpc("login_with_pin", { identifier: input.value.trim(), pin_value: pin });
			if (!result.ok) { pad.clear(); pad.shake(); say(result.message, "error"); return; }
			const data = result.data;
			if (data.switch_required) { screenSwitch(data.switch_token); return; }
			if (data.ok) { state.csrf = data.csrf_token || state.csrf; go(data.redirect_to, data.home); return; }
			if (data.needs_otp) { tabs.select("otp"); screenOtpStart(input.value, S.pin_needs_otp); return; }
			pad.clear(); pad.shake(); say(fill(S.wrong_pin, String(data.tries_left)), "error");
		}
	}

	/* ---- password sign-in: a mobile number (or email) and the password the person chose ---- */
	function screenPasswordLogin(prefill, note) {
		const input = identifierField(prefill);
		const secret = secretField("current-password", S.password_label);
		const submit = h("button", { type: "submit", class: "btn btn-primary btn-block rfhq-auth__primary", text: S.sign_in });
		const form = h("form", { class: "rfhq-auth__form", novalidate: true }, h("h3", { class: "rfhq-auth__title", text: S.password_title }), input, secret.el, submit,
			link(S.forgot_password, () => screenForgotPassword(input.value)), link(S.code_instead, () => { tabs.select("otp"); screenOtpStart(input.value); }),
			link(S.staff_sign_in, () => showStandardFields()));
		form.addEventListener("submit", async (event) => {
			event.preventDefault();
			if (!input.value.trim()) { say(S.identifier_needed, "error"); input.focus(); return; }
			busy(submit, true);
			const result = await rpc("login_with_password", { identifier: input.value.trim(), password_value: secret.input.value });
			busy(submit, false);
			if (!result.ok) { say(result.message, "error"); return; }
			const data = result.data;
			if (data.switch_required) { screenSwitch(data.switch_token); return; }
			if (data.ok) { state.csrf = data.csrf_token || state.csrf; go(data.redirect_to, data.home); return; }
			secret.input.value = ""; secret.input.focus();
			say(fill(S.wrong_password, String(data.tries_left)), "error");
		});
		show(form);
		if (note) say(note, "info");
	}

	/* Staff keep the standard email-and-password fields: show them, with a way back to ours. */
	function showStandardFields() {
		passwordBlocks.forEach((block) => { block.hidden = false; });
		show(link(cfg.password ? S.use_password : S.use_otp, () => { passwordBlocks.forEach((block) => { block.hidden = true; }); cfg.password ? screenPasswordLogin() : screenOtpStart(); }));
	}

	/* ---- forgot the password: a code, then a new password ---- */
	function screenForgotPassword(prefill) {
		const start = (identifier, channel) => rpc("start_password_reset", { identifier, channel });
		show(identifierForm({
			prefill, title: S.reset_password_title, start, back: (value) => screenPasswordLogin(value),
			onSent: (data, input) => {
				const ctx = {
					masked: data.masked_identifier, reference: data.reference, resendIn: data.resend_in, length: data.length,
					resend: () => start(input.value.trim(), undefined),
					back: () => screenForgotPassword(input.value),
					// The code is checked together with the new password, so the new password is asked for first.
					collect: (reference, code) => screenNewPassword({
						save: async (password) => {
							const out = await rpc("complete_password_reset", { reference, code, new_password: password });
							if (out.ok && !out.data.reset) {
								screenCode(Object.assign({}, ctx, { reference, resendIn: 0 }));
								say(reasonText(out.data), "error");
								return { ok: false, message: "", leave: true };
							}
							return out;
						},
						done: () => { tabs.select("password"); screenPasswordLogin(input.value, S.password_updated); },
					}),
				};
				screenCode(ctx);
			},
		}));
	}

	function screenNewPassword({ save, done }) {
		const secret = secretField("new-password", S.password_label);
		const submit = h("button", { type: "submit", class: "btn btn-primary btn-block rfhq-auth__primary", text: S.verify });
		const form = h("form", { class: "rfhq-auth__form", novalidate: true }, h("h3", { class: "rfhq-auth__title", text: S.new_password_title }), secret.el,
			h("p", { class: "rfhq-auth__hint", text: fill(S.password_hint, String(cfg.password_length || 8)) }), submit);
		form.addEventListener("submit", async (event) => {
			event.preventDefault();
			busy(submit, true);
			const result = await save(secret.input.value);
			busy(submit, false);
			if (result.leave) return;
			if (!result.ok) { say(result.message, "error"); return; }
			done();
		});
		show(form);
	}

	/* ---- forgot PIN: OTP, then a new PIN ---- */
	function screenForgot(prefill) {
		const start = (identifier, channel) => rpc("start_pin_reset", { identifier, channel });
		show(identifierForm({
			prefill, title: S.reset_title, start, back: (value) => screenPinLogin(value),
			onSent: (data, input) => {
				const ctx = {
					masked: data.masked_identifier, reference: data.reference, resendIn: data.resend_in, length: data.length,
					resend: () => start(input.value.trim(), undefined),
					back: () => screenForgot(input.value),
					// The OTP is checked together with the new PIN, so the PIN is asked for first.
					collect: (reference, code) => screenSetPin({
						title: S.reset_title, skippable: false,
						save: async (pin) => {
							const out = await rpc("complete_pin_reset", { reference, code, new_pin: pin });
							if (out.ok && !out.data.reset) {
								screenCode(Object.assign({}, ctx, { reference, resendIn: 0 }));
								say(reasonText(out.data), "error");
								return { ok: false, message: "", leave: true };
							}
							return out;
						},
						done: () => { tabs.select("pin"); screenPinLogin(input.value, S.pin_updated); },
					}),
				};
				screenCode(ctx);
			},
		}));

	/* ---- Google One Tap, proved by the site's Firebase project: the Google card gives a Google token, Firebase turns it into its own token, the server checks that ---- */
	function googleOneTap(gc) {
		const started = (async () => {
			for (const src of gc.scripts || []) await loadScript(src);
			await loadScript("https://accounts.google.com/gsi/client");
			await loadScript(gc.module);
			const part = (window.rfhqGoogleProof || {}).firebase;
			if (!part || !window.google || !google.accounts || !google.accounts.id) return;
			google.accounts.id.initialize({
				client_id: gc.google_client_id,
				auto_select: false,
				cancel_on_tap_outside: true,
				callback: async (resp) => {
					let token;
					try { token = await part.signIn(gc.options, resp.credential); } catch (e) { say(S.proof_wrong, "error"); return; }
					const result = await rpc("complete_google_signin", { proof: token, intent: intent() });
					if (result.ok && result.data && result.data.verified) { track("sign_in_done", { method: "google" }); signedIn(result.data); return; }
					say(S.proof_wrong, "error");
				},
			});
			google.accounts.id.prompt();
		})();
		started.catch(() => { /* no card: the other ways in stay as they are */ });
	}
	}
})();
